<template>
  <!-- 活动详情 -->
  <div class="g-content">
    <div class="page-activity-detail">
      <div class="header">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/activity/activity-manage' }">社教活动管理</el-breadcrumb-item>
          <el-breadcrumb-item>查看详情 - {{ detailData.activityStatusName }}</el-breadcrumb-item>
        </el-breadcrumb>
        <a class="to-back" @click="goBack">
          <i class="el-icon-back"></i>&nbsp;&nbsp;返回
        </a>
      </div>
      <el-divider></el-divider>
      <div class="content">
        <div class="head-info" style="display: table;position: relative;width: 100%;">
          <div class="pic-box" style="display: table-cell;width: 25%;vertical-align: middle;">
            <img :src="detailData.pictureUrl" alt>
          </div>
          <div style="display: table-cell;width:75%;">
            <el-row>
              <el-row>
                <el-col :span="4" class="label tr">名称</el-col>
                <el-col :span="8" class="name">{{ detailData.activityName }}</el-col>
                <el-col :span="4" class="label tr">类型</el-col>
                <el-col :span="8" class="name">{{ detailData.typeName }}</el-col>
              </el-row>

              <el-row>
                <el-col :span="4" class="label tr">时间</el-col>
                <el-col :span="8" class="name" v-if="detailData.type == 3">{{ detailData.activityTime }} - {{ detailData.activityTimeEnd }}</el-col>
                <el-col :span="8" class="name" v-else>{{ detailData.activityTime }}</el-col>

                <el-col :span="4" class="label tr">名额</el-col>
                <el-col :span="8" class="name">{{ detailData.quota }}</el-col>
              </el-row>

              <el-row>
                <el-col :span="4" class="label tr">地点</el-col>
                <el-col :span="8" class="name">{{ detailData.activityAddr }}</el-col>
                <el-col :span="4" class="label tr">已报名</el-col>
                <el-col :span="8" class="name">{{ detailData.signCount }}</el-col>

              </el-row>

              <!-- <el-col :span="4" class="label tr">要求</el-col>
              <el-col :span="8" class="name">{{detailData.demand}}</el-col>

              <el-col :span="4" class="label tr">取消报名</el-col>
              <el-col :span="8" class="name">{{detailData.cancelSign}}</el-col>-->
            </el-row>

            <el-row class="box-flex" style="display:flex;">
              <div class="label tr">要求</div>
              <!-- <div :span="8" class="name">{{detailData.servicePlace}}</div> -->
              <div class="name">{{ detailData.demand }}</div>

              <div class="label tr">取消报名</div>
              <div class="name">{{ detailData.cancelSign }}</div>
            </el-row>
            <el-row v-if="detailData.type == 3">
              <el-col :span="4" class="label tr">年龄范围</el-col>
              <el-col :span="8" class="name">{{ detailData.ageStr }}</el-col>
            </el-row>

          </div>
        </div>

        <div class="con mt-20">
          <h2 class="title clearfix">
            <span>当前活动状态：{{ detailData.activityStatusName }}</span>
            <el-button class="fr mt-10 ml-10" @click="handleExport">导出报名表</el-button>
            <!-- <el-button type="primary" class="fr mt-10" :disabled="detailData.activityStatus != 1" @click="handleAdd"> 添加报名</el-button> -->
          </h2>

          <!-- 统计数据 -->
          <div class="box box-statistc">
            <p class="tit">统计数据</p>

            <div class="my-table">
              <el-row class="my-table-item">
                <el-col :span="4" class="label"></el-col>
                <el-col :span="5" class="txt" v-for="(item, index) in useMoreList" :key="index">{{ item.name }}</el-col>
                <!-- <el-col :span="3" class="txt">查看次数</el-col> -->
              </el-row>
              <el-row class="my-table-item list">
                <el-col :span="4">
                  <div class="label">活动次数</div>
                </el-col>
                <el-col class="txt" :span="5" v-for="(item, index) in useMoreList" :key="index">
                  <div class="label">{{ item.obj.count1 }}</div>
                </el-col>
              </el-row>
            </div>
          </div>

          <!-- 报名列表 -->
          <div class="box box-signup">
            <p class="tit">报名列表</p>
            <!-- 表格 -->
            <div class="table">
              <el-table stripe :data="tableData" v-loading="listLoading">
                <el-table-column label="序号" width="50">
                  <template slot-scope="scope">{{ scope.$index + 1 }}</template>
                </el-table-column>
                <el-table-column label="报名时间" min-width="15%">
                  <template slot-scope="scope">{{ scope.row.enrollTime | DateFormat('yyyy-MM-dd') }}</template>
                </el-table-column>
                <el-table-column prop="realName" label="学生姓名" min-width="10%"></el-table-column>
                <el-table-column prop="userPhone" label="家长联系方式" min-width="15%"></el-table-column>
                <el-table-column prop="enrollType" label="报名方式" min-width="10%"></el-table-column>
                <el-table-column prop="dataState" label="报名状态" min-width="10%"></el-table-column>
                <el-table-column prop="absentCount" v-if="detailData.type != 3" label="累计缺席次数" min-width="10%"></el-table-column>
                <el-table-column v-if="detailData.type == 3" prop="isPass" label="审核结果" min-width="10%">
                  <template slot-scope="scope">{{ scope.row.isPass == 1 ? '审核通过' : scope.row.isPass == 0
                    ? '审核不通过' : '未审核' }}</template>

                </el-table-column>

                <el-table-column fixed="right" label="操作" min-width="20%">
                  <!-- 小讲解员审核 -->
                  <div v-if="detailData.type == 3" slot-scope="scope">
                    <a class="m-btn mr-10" @click="getDetail(scope.row)">详情</a>
                    <span v-if="scope.row.isPass == null">
                      <a class="m-btn mr-10" @click="tempExhibitionPass(scope.row)">审核通过</a>
                      <a class="m-btn mr-10 m-danger" @click="tempExhibitionNotPass(scope.row)">审核不通过</a>
                    </span>
                    <a class="m-btn mr-10" @click="handleExportPerson(scope.row)">导出</a>

                  </div>

                  <div v-else slot-scope="scope">
                    <!-- 报名中 -->
                    <a class="m-btn mr-10" @click="handleOperate('1', scope.row)"
                       v-if="detailData.activityStatus === '1' && scope.row.dataState === '已报名'">取消</a>
                    <!-- 报名结束 -->
                    <span v-if="detailData.activityStatus === '2'">
                      <a class="m-btn mr-10" @click="handleOperate('2', scope.row)" v-if="scope.row.joinState === '0'">参加</a>
                      <a class="m-btn mr-10" @click="handleOperate('3', scope.row)" v-if="scope.row.joinState === '1'">缺席</a>
                    </span>
                    <!-- 报名结束 -->
                    <a class="m-btn mr-10" style="color: red" @click="handleOperate('4', scope.row)" v-if="scope.row.userDataState === '1'">拉黑</a>
                    <a class="m-btn mr-10" style="color: red" @click="handleOperate('4', scope.row)" v-if="scope.row.userDataState === '2'">解冻</a>
                  </div>

                </el-table-column>
              </el-table>

              <div class="pagination-container tr">
                <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" :page-sizes="[5, 10, 15, 20, 30]"
                               background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
                               @current-change="handleCurrentChange" />
              </div>
            </div>
          </div>

          <!-- 评论列表-注释 -->
          <!-- <div class="box box-comment">
            <p class="tit">评论列表</p>
            <div class="comment-list">
              <div class="item" v-for="i in 5" :key="i">
                <div class="left">
                  <img src alt :onerror="defaultHeadImg">
                  <p class="tc mt-10">张娟</p>
                </div>
                <div class="right">
                  <p
                    class="desc"
                  >善与孝，一直是中华民族最为重要的传统美德之一，是每位青少年学生都应学习和践行的。从古至今，中国涌现出许多感人肺腑的孝善事迹，成为我们学习的榜样和楷模。而最被济南人所熟知的孝行楷模，当属闵子骞了。</p>
                  <p class="time mt-20">
                    <span>2020-01-01 17:02:01</span>
                    <a class="m-des ml-20">删除</a>
                  </p>
                </div>
              </div>

              <div class="pagination-container tr">
                <el-pagination
                  :current-page="listQuery2.currentPage"
                  :page-size="listQuery2.size"
                  :total="total2"
                  background
                  layout="total, prev, pager, next, sizes, jumper"
                  @size-change="handleSizeChange2"
                  @current-change="handleCurrentChange2"
                />
              </div>
            </div>
          </div>-->
        </div>
      </div>
    </div>

    <dialogAddSignup ref="dialogAddSignup" @refresh="refreshDetail"></dialogAddSignup>

    <litter-volunteer-detail ref="litterVolunteerDetail"></litter-volunteer-detail>

  </div>
</template>

<script>
import dialogAddSignup from './dialog-add-signup'
import litterVolunteerDetail from './litter-volunteer-detail'

export default {
  components: {
    dialogAddSignup,
    litterVolunteerDetail
  },
  data() {
    return {
      defaultHeadImg: this.$store.state.app.defaultHeadImg,
      detailData: {},
      useMoreList: [
        {
          name: '累计报名',
          obj: {
            count1: ''
          }
        },
        {
          name: '已报名',
          obj: {
            count1: ''
          }
        },
        {
          name: '已取消',
          obj: {
            count1: ''
          }
        },
        {
          name: '活动评论',
          obj: {
            count1: ''
          }
        }
      ],
      tableData: [],
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 5
      },
      total: 0,
      commentList: [],
      listQuery2: {
        currentPage: 1,
        size: 5
      },
      total2: 0
    }
  },
  methods: {
    // 初始化表格
    getDetailData() {
      this.$http
        .get('/bsActivity/getDetail', {
          id: this.$route.query.id
        })
        .then((res) => {
          if (res.success) {
            let data = res.result
            this.detailData = data
            this.useMoreList = [
              {
                name: '累计报名',
                obj: {
                  count1: data.sum
                }
              },
              {
                name: '已报名',
                obj: {
                  count1: data.signCount
                }
              },
              {
                name: '已取消',
                obj: {
                  count1: data.cancelSign
                }
              },
              {
                name: '活动评论',
                obj: {
                  count1: data.assessCount
                }
              }
            ]
          } else {
            this.$message.error(res.message)
          }
        })
    },

    getDetail(obj) {
      this.$refs.litterVolunteerDetail.init(obj.userId, 'detail')
    },

    tempExhibitionPass(obj) {
      this.$common.confirm(
        {
          title: '审核确认',
          content: '是否通过？'
        },
        () => {
          this.$http
            .get('/bsActivity/pass', {
              id: obj.id
            })
            .then((res) => {
              if (res.success) {
                this.$message.success('审核通过')
                this.getDataList()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },

    tempExhibitionNotPass(obj) {
      this.$common.confirm(
        {
          title: '审核确认',
          content: '是否不通过？'
        },
        () => {
          this.$http
            .get('/bsActivity/notPass', {
              id: obj.id
            })
            .then((res) => {
              if (res.success) {
                this.$message.success('审核不通过')
                this.getDataList()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },
    // 报名列表
    getDataList() {
      this.listLoading = true
      this.$http
        .get('/bsActivity/getSignListById', {
          ...this.listQuery,
          key: this.$route.query.id
        })
        .then((res) => {
          this.listLoading = false
          if (res.success) {
            this.tableData = res.result
            this.total = res.page.allRow
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 评论
    getCommentList() {
      this.$http
        .get('/user/listApproval', {
          ...this.listQuery2
        })
        .then((res) => {
          if (res.success) {
            this.commentList = res.result
            this.total2 = res.page.allRow
          } else {
            this.$message.error(res.message)
          }
        })
    },
    refreshDetail() {
      this.getDetailData()
      this.restList()
    },
    // 重置查询
    restList() {
      this.listQuery.currentPage = 1
      this.getDataList()
    },
    handleAdd(obj) {
      if (this.detailData.type == 3) {
        this.$refs.litterVolunteerDetail.init(this.detailData.id, 'add')
      } else {
        this.$refs.dialogAddSignup.init()
      }
    },
    handleExport() {
      location.href =
        '/singleMuseum/bsActivity/exportData?key=' + this.$route.query.id
    },

    handleExportPerson(obj) {
      location.href = '/singleMuseum/bsActivity/print?userId=' + obj.userId
    },
    handleOperate(type, item) {
      let strMsg = ''
      switch (type) {
        case '1':
          strMsg = '取消报名成功'
          break
        case '2':
          strMsg = '参加操作成功'
          break
        case '3':
          strMsg = '缺席操作成功'
          break
        case '4':
          strMsg = '解冻操作成功'
          break
      }
      if (type === '4') {
        this.handleStatus(item)
        return
      }
      this.$http
        .put('/bsActivity/operationUserActivity', {
          id: item.id, // 报名表ID
          operate: type // 1-取消报名 2-已参加 3-未参加
        })
        .then((res) => {
          if (res.success) {
            this.$message.success(strMsg)
            this.getDetailData()
            this.getDataList()
            this.getCommentList()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 拉黑/解冻
    handleStatus(item) {
      let str = item.userDataState === '1' ? '拉黑' : '解冻'
      this.$common.confirm(
        {
          title: '您正在' + str + '用户，是否确认' + str + '？',
          className: 'cus-confirm-375'
        },
        () => {
          this.$http
            .put('/bsPubUser/removeBlack', {
              id: item.userId,
              type: item.userDataState === '1' ? '2' : '1' // 1-移出 2-移入
            })
            .then((res) => {
              if (res.success) {
                this.$message.success(str + '成功')
                this.getDataList()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },
    goBack() {
      this.$router.push({ path: '/activity/activity-manage' })
    },
    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getDataList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getDataList()
    },
    handleSizeChange2(val) {
      this.listQuery2.size = val
      this.getCommentList()
    },
    // 点击序号
    handleCurrentChange2(val) {
      this.listQuery2.currentPage = val
      this.getCommentList()
    }
  },
  created() {
    this.getDetailData()
    this.getDataList()
    this.getCommentList()
  }
}
</script>

<style lang="scss" scoped>
.page-activity-detail {
  .header {
    position: relative;

    .el-breadcrumb {
      font-size: 18px;

      /deep/.el-breadcrumb__inner {
        font-weight: bold;
        color: rgba(87, 89, 98, 1);
      }

      /deep/.el-breadcrumb__inner.is-link,
      .el-breadcrumb__inner a {
        color: #9699a2;
      }
    }

    .to-back {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 14px;
      color: #9699a2;
    }
  }

  .content {
    font-size: 14px;

    .head-info {
      font-size: 14px;
      // line-height: 40px;
      border: solid 1px $border;
      border-bottom: none;
      border-right: none;

      .pic-box {
        padding: 10px;
        box-sizing: border-box;
        // height: 160px;
        border-right: solid 1px $border;
        border-bottom: solid 1px $border;
        display: flex;

        img {
          max-width: 100%;
          // max-height: 100%;
          max-height: 140px;
          margin: auto;
          display: block;
        }
      }

      .label,
      .name {
        padding: 5px 20px;
        border-right: solid 1px $border;
        border-bottom: solid 1px $border;
        // height: 40px;
        line-height: 30px;
      }

      .label {
        background: #fcfcfe;
      }

      .box-flex {
        .label {
          box-sizing: border-box;
          width: 16.66667%;
        }

        .name {
          box-sizing: border-box;
          width: 33.33333%;
        }
      }
    }

    .con {
      border: solid 1px $border;

      h2.title {
        padding: 0 20px;
        line-height: 60px;
        border-bottom: solid 1px $border;
        color: $danger;
      }

      .box {
        padding: 10px 20px;

        .tit {
          padding: 10px 0;
        }
      }

      .box.box-comment {
        .comment-list {
          padding: 20px 10px 20px 40px;

          .item {
            padding: 20px 0;
            display: flex;
            color: $color5;
            border-bottom: solid 1px $border;

            .left {
              img {
                width: 40px;
                height: 40px;
              }
            }

            .right {
              padding-left: 40px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            }

            &:nth-child(5n) {
              border-bottom: none;
            }
          }
        }
      }
    }

    .my-table-item.list {
      .label {
        border-bottom: solid 1px $border;
      }

      .txt {
        padding: 0;
      }
    }
  }

  .my-table {
    display: inline-block;
    width: 100%;

    .my-table-item {
      display: flex;
      justify-content: space-around;
      line-height: 30px;
      border: solid 1px $border;
      border-bottom: none;
      text-align: center;
      font-size: 14px;

      .txt {
        padding: 0 5px;
        border-left: solid 1px $border;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>


